import { AuthProvider } from 'hooks/useAuth'
import { StoreProvider } from 'hooks/useStore'
import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './fonts/roc-grotesk/stylesheet.css'
import '@fontsource/roboto'
import '@fontsource/roboto/300.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
import 'react-phone-input-2/lib/style.css'
import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'
import 'swiper/css/autoplay'
import 'swiper/css/scrollbar'
import 'swiper/css/effect-cards'
import 'react-datetime-picker/dist/DateTimePicker.css'
import 'react-calendar/dist/Calendar.css'
import 'rc-slider/assets/index.css'
import 'utils/font-awesome'
import 'simplebar-react/dist/simplebar.min.css'

import './index.css'
import { ApolloProvider } from '@apollo/client'
import Apollo from 'graphql/apollo'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import moment from 'moment-timezone'
import { HelmetProvider } from 'react-helmet-async'
import { AuthModalProvider } from 'contexts/auth-modal-context'
import { ModalManagerProvider } from 'contexts/modal-manager-context'
import { initMixpanel } from 'services/mixpanel'

moment.tz.setDefault()

// Initialize Mixpanel
initMixpanel()

console && console.log('frontend build: %s (%s) %s', __BUILD__.branchName, __BUILD__.commitHash, __BUILD__.commitDate)

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<LocalizationProvider dateAdapter={AdapterMoment} dateLibInstance={moment}>
			<AuthProvider>
				<ApolloProvider client={Apollo.getInstance().client}>
					<StoreProvider>
						<AuthModalProvider>
							<ModalManagerProvider>
								<HelmetProvider>
									<App />
								</HelmetProvider>
							</ModalManagerProvider>
						</AuthModalProvider>
					</StoreProvider>
				</ApolloProvider>
			</AuthProvider>
		</LocalizationProvider>
	</React.StrictMode>
)
